<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      class="client-edit"
      max-width="600"
      @close="$emit('close')"
    >
      <v-card>
        <v-card-title>
          Integrate NERIS for {{ clientName }}
        </v-card-title>
        <v-card-text>
          <v-alert
            v-if="errorAlert"
            type="error"
            outlined
            transition="scale-transition"
            class="mt-2"
          >
            {{ errorMessage }}
          </v-alert>
          <v-text-field
            v-model="nerisId"
            v-validate="{ required: true }"
            label="NERIS Entity ID"
            name="nerisId"
            maxlength="10"
            :error-messages="errors.collect('nerisId')"
          />
          <v-text-field
            v-model="nerisClientId"
            v-validate="{ required: true }"
            label="Client ID"
            name="nerisClientId"
            :error-messages="errors.collect('nerisClientId')"
          />
          <v-text-field
            v-model="nerisClientSecret"
            v-validate="{ required: true }"
            label="Client Secret"
            name="nerisClientSecret"
            :type="showSecret ? 'text' : 'password'"
            :append-icon="showSecret ? 'visibility_off' : 'visibility'"
            :error-messages="errors.collect('nerisClientSecret')"
            @click:append="showSecret = !showSecret"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="blue darken-1"
            text
            @click.native="cancel()"
          >Cancel</v-btn>
          <v-btn
            :loading="integrating"
            color="primary"
            text
            @click.native="integrate()"
          >Integrate</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import errorAlertMixins from '@/mixins/errorAlertMixins';
import neris from '@/api/neris';

export default {
  name: 'IntegrateNerisWithCredentialsPopup',
  mixins: [errorAlertMixins],
  data() {
    return {
      dialog: false,
      clientId: null,
      clientName: null,
      integrating: false,
      showSecret: false,
      nerisId: null,
      nerisClientId: null,
      nerisClientSecret: null,
      dictionary: {
        attributes: {
          nerisId: 'NERIS Entity ID',
          nerisClientId: 'Client ID',
          nerisClientSecret: 'Client Secret',
        },
      },
    };
  },
  mounted() {
    this.$validator.localize('en', this.dictionary);
  },
  methods: {
    show(clientId, name) {
      this.hideError();
      this.clientId = clientId;
      this.clientName = name;
      this.nerisId = null;
      this.nerisClientId = null;
      this.nerisClientSecret = null;
      this.showSecret = false;
      this.dialog = true;
    },

    cancel() {
      this.dialog = false;
    },

    async integrate() {
      this.hideError();
      await this.$validator.reset();
      if (!await this.$validator.validateAll()) {
        return;
      }
      try {
        this.integrating = true;
        await neris.integrateClientWithCredentials(this.clientId, {
          nerisId: this.nerisId,
          nerisClientId: this.nerisClientId,
          nerisClientSecret: this.nerisClientSecret,
        });
        this.onSuccess();
      } catch (e) {
        this.parseErrorResponse(e.response, true);
      } finally {
        this.integrating = false;
      }
    },

    onSuccess() {
      this.$emit('integrated', {
        clientId: this.clientId,
        nerisId: this.nerisId,
        hasIntegration: true,
      });
      this.dialog = false;
    },
  },
};
</script>
